import { companyService } from 'services';
import { useState } from 'react';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { companyAdacter } from 'adapters';
import useErrors from 'hooks/useErrors';
import { toast } from 'react-toastify';
import { contextApp } from 'context';
import { setItemToStore } from 'helpers/utils';

const useCompany = (id = false) => {
 const { auth, setAuth } = contextApp();
 const [isLoading, setIsLoading] = useState(false);
 const { setError } = useErrors();

 const { consultCompanyByNit, updateCompany, getCompany } = companyService.useApiCompany();
 const queryClient = useQueryClient();
 const mutateConsult = useMutation(consultCompanyByNit);
 const { mutate: mutateUpdate } = useMutation(updateCompany);

 const { data } = useQuery(['companyData'], () => getCompany(id), {
  onError: err => setError(err),
  onSettled: dt => console.log(dt, 'termino la solicitud')
 });

 const onSubmitData = async newData => {
  setIsLoading(true);
  const dataSend = await companyAdacter.update(newData);
  console.log(dataSend, 'datos preparados antes de enviar');
  mutateUpdate(dataSend, {
   onError: err => setError(err),
   onSettled: () => setIsLoading(false),
   onSuccess: obj => {
    //console.log(obj, 'respuesta del servidor');
    queryClient.invalidateQueries(['companyData']);
    setAuth({ ...auth, company: obj });
    setItemToStore('sesion', { ...auth, company: obj });
    toast.success('Datos actualizados correctamente');
   }
  });
 };

 const onError = err => {
  console.log('se produjo un error ', err);
  //if (!validation) clearErrors();
 };

 const consultCompany = nit => {
  mutateConsult.mutate(nit, {
   onSuccess: obj => ({ ...obj })
  });
 };

 return { isLoading, data, consultCompany, onError, onSubmitData };
};

export default useCompany;
